import React from "react";
import { useDispatch } from "react-redux";
import CookieBannerCommon from "@clarion/feature/dist/SiteComponents/components/CookieBanner";
import withFieldsCheck from "@clarion/foundation/dist/Helpers/containers/WithFieldsCheck/index";
import {
    toggleCookieAnalytics,
    toggleCookieThirdParty,
    toggleCookieMarketing
} from "@clarion/foundation/dist/Settings/actions/globalActions";
import { gtmEnable, gtmId } from "../../../../groupsiteConfig";
import "./index.css";
import { buildOptOutLinks } from "@clarion/foundation/dist/Utils/buildOptOutLinks";

const CookieBanner = ({ fields }) => {
    const dispatch = useDispatch();
    const optionalCookies = [
        {
            name: "analytics",
            label: fields.AnalyticsName.value,
            description: fields.AnalyticsDescription.value,
            cookies: ["_ga", "_gid"],
            onAccept: () => {
                let gtmScript = document.getElementById("gtm-script");

                dispatch(toggleCookieAnalytics(true));

                if (gtmEnable.toString() === "true" && gtmScript === null) {
                    const scriptTag = document.getElementsByTagName("script")[0];

                    gtmScript = document.createElement("script");

                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        "gtm.start": new Date().getTime(),
                        event: "gtm.js"
                    });

                    gtmScript.async = true;
                    gtmScript.src = "https://www.googletagmanager.com/gtm.js?id=" + gtmId;
                    gtmScript.id = "gtm-script";

                    scriptTag.parentNode.insertBefore(gtmScript, scriptTag);
                }
            },
            onRevoke: () => {
                dispatch(toggleCookieAnalytics(false));
            }
        },
        {
            name: "marketing",
            label: fields.MarketingName.value,
            description: fields.MarketingDescription.value,
            cookies: [],
            onAccept: () => {
                dispatch(toggleCookieMarketing(true));
            },
            onRevoke: () => {
                dispatch(toggleCookieMarketing(false));
            }
        },
        {
            name: "thirdParty",
            label: fields.ThirdPartyName.value,
            description: fields.ThirdPartyDescription.value,
            cookies: ["_fbp", "fr"],
            onAccept: () => {
                // Facebook pixel tracking
                const tracking = (windowEl, documentEl, elementType, scriptSrc) => {
                    // Arguments declared in this specific order because of the arguments keyword further down
                    let fbqMethod;
                    let trackingScript;
                    let firstScriptElement;

                    if (windowEl.fbq) {
                        return;
                    }

                    windowEl.fbq = function () {
                        if (fbqMethod.callMethod) {
                            fbqMethod.callMethod.apply(fbqMethod, arguments);
                        } else {
                            fbqMethod.queue.push(arguments);
                        }
                    };

                    fbqMethod = windowEl.fbq;

                    if (!windowEl._fbq) {
                        windowEl._fbq = fbqMethod;
                    }

                    fbqMethod.push = fbqMethod;
                    fbqMethod.loaded = true;
                    fbqMethod.version = "2.0";
                    fbqMethod.queue = [];
                    trackingScript = documentEl.createElement(elementType);
                    trackingScript.async = true;
                    trackingScript.src = scriptSrc;
                    firstScriptElement = documentEl.getElementsByTagName(elementType)[0];
                    firstScriptElement.parentNode.insertBefore(trackingScript, firstScriptElement);
                };

                dispatch(toggleCookieThirdParty(true));

                tracking(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
                window.fbq("init", "263538584999916");
                window.fbq("track", "PageView");
            },
            onRevoke: () => {
                dispatch(toggleCookieThirdParty(false));

                window.fbq("consent", "revoke");
            },
            thirdPartyCookies: buildOptOutLinks(fields)
        }
    ];

    return <CookieBannerCommon fields={fields} optionalCookies={optionalCookies} />;
};

export default withFieldsCheck(CookieBanner);
